import { render, staticRenderFns } from "./ReviewsBlock.vue?vue&type=template&id=59db50b6&scoped=true&"
import script from "./ReviewsBlock.vue?vue&type=script&lang=js&"
export * from "./ReviewsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsBlock.vue?vue&type=style&index=0&id=59db50b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db50b6",
  null
  
)

export default component.exports